<script>
import { mapGetters, mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  props: {
    staffId: {
      type: String,
      default: null,
    },
    branchId: {
      type: String,
      default: null,
    },
    refreshPage: {
      type: Function,
      default: () => {},
    },
    resetAssignStaffService: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      serviceId: null,
    };
  },
  computed: {
    ...mapGetters('appointments', ['serviceList']),
  },
  methods: {
    ...mapActions('appointments', ['assignStaffService', 'fetchServices']),

    async handleAssignStaffService() {
      if (!this.serviceId) {
        useAlert(this.$t('BRANCHES.CREATE_STAFF_SERVICES_MODAL.SERVICE_REQUIRED'));
        return;
      }
      try {
        const payload = {
          service_id: this.serviceId,
        };
        await this.assignStaffService({ staffId: this.staffId, payload });
        useAlert(this.$t('BRANCHES.CREATE_STAFF_SERVICES_MODAL.SUCCESS'));
      } catch (err) {
        console.error(err);
        useAlert(err);
      } finally {
        this.refreshPage();
        this.resetAssignStaffService();
      }
    },
  },
  async mounted() {
    try {
      await this.fetchServices(this.branchId);
    } catch (err) {
      console.error(err);
      useAlert(err);
    }
  },
};
</script>
<template>
  <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
    <!-- Input Field -->
    <select v-model="serviceId">
      <option :value="null" disabled>{{ $t('BRANCHES.CREATE_STAFF_SERVICES_MODAL.SELECT_SERVICE') }}</option>
      <option 
        v-for="service in serviceList.results" 
        :key="service.service_id" 
        :value="service.service_id"
      >
        {{ service.service_name }}
      </option>
    </select>

    <!-- Action Button -->
    <button 
      @click="handleAssignStaffService()"
      class="w-full py-2 mt-2 text-white font-medium rounded-md transition 
        bg-woot-600 hover:bg-woot-700 focus:ring-2 focus:ring-woot-400 focus:outline-none"
    >
      {{ $t('BRANCHES.CREATE_STAFF_SERVICES_MODAL.ASSIGN') }}
    </button>
  </div>
</template>

